export default {
  authUser(state, data) {
    state.token = data.access_token;
    state.checkNewRegister = data.isNew;
  },

  setPanelToken(state, data) {
    state.token = data;
  },

  clearAuth(state) {
    state.token = null;
    state.registerToken = null;
    state.checkNewRegister = false;
  },

  setRegisterCode(state, data) {
    state.registerCode = data;
  },

  setRegisterAuth(state, data) {
    state.registerToken = data.access_token;
    state.checkNewRegister = data.isNew;
  },

  setForgotCode(state, data) {
    state.forgotCode = data;
  },

  setProfile(state, data) {
    state.profile = data;
  },

  setCompanies(state, data) {
    state.companies = data;
  },

  setCompany(state, data) {
    state.company = data;
  },

  setPrintCompany(state, data) {
    state.printCompany = data;
  },

  setTransactions(state, data) {
    state.transactions = data;
  },

  setWallet(state, data) {
    state.wallet = data;
  },

  setPaymentGateway(state, data) {
    state.paymentGateway = data;
  },

  setMilitaryService(state, data){
    state.militaryService = data
},

  setPaymentResult(state, data) {
    state.paymentResult = data;
  },

  setInvoices(state, data) {
    state.invoices = data;
  },
  setInvoiceById(state, data) {
    state.invoiceById = data;
  },

  setBillSubjects(state, data) {
    state.billSubjects = data;
  },

  setBillTypes(state, data) {
    state.billTypes = data;
  },

  setBillPatterns(state, data) {
    state.billPatterns = data;
  },

  setBuyerTypes(state, data) {
    state.buyerTypes = data;
  },

  setFlightTypes(state, data) {
    state.flightTypes = data;
  },

  setClearingMethods(state, data) {
    state.clearingMethods = data;
  },

  setPaymentTypes(state, data) {
    state.paymentTypes = data;
  },

  setUnitMeasurements(state, data) {
    state.unitMeasurements = data;
  },

  setCurrencyTypes(state, data) {
    state.currencyTypes = data;
  },

  setInquiryInvoice(state, data) {
    state.inquiryInvoiceLogs = data;
  },

  setInquiryCheck(state, data) {
    state.inquiryCheck = data;
  },

  setForgotCheck(state, data) {
    state.forgotCheck = data;
  },

  setInvoiceFileLink(state, data) {
    state.invoiceFileLink = data;
  },

  setPrintAddress(state, data) {
    state.printAddress = data;
  },

  setTaxkeys(state, data) {
    state.taxKeys = data;
  },

  setTaxkeyByNational(state, data) {
    state.taxKeyByNational = data;
  },

  setPublicKeyLink(state, data) {
    state.publicKeyLink = data;
  },

  setPfxResult(state, data) {
    state.pfxResult = data;
  },

  setCompanyFinalPrice(state, data) {
    state.companyFinalPrice = data;
  },
  setJobAdvertisement(state, data) {
    state.jobAdvertisement = data;
  },
  setJobAdvertisementById(state, data) {
    state.jobAdvertisementById = data;
  },
  setJobRequest(state, data) {
    state.jobRequest = data;
  },
  setJobRequestById(state, data) {
    state.jobRequestById = data;
  },
  
  setNews(state, data) {
    state.news = data;
  },
  setNewsDetail(state, data) {
    state.newsDetail = data;
  },
};
